// removed by extract-text-webpack-plugin
module.exports = {"item-category":"item-category","des-category":"des-category","des-category-wrap-img":"des-category-wrap-img","product-wrap":"product-wrap","product":"product","des-category-name":"des-category-name","view-more":"view-more","view-more-link":"view-more-link"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/item-category/style.scss
// module id = ./components/partials/item-category/style.scss
// module chunks = 0